var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.2146C16.5818 20.2146 20.2437 16.508 20.2437 12C20.2437 7.49201 16.5818 3.78536 12 3.78536C7.41825 3.78536 3.75626 7.49201 3.75626 12C3.75626 16.508 7.41825 20.2146 12 20.2146ZM20.5 12C20.5 16.6943 16.6945 20.5 12 20.5C7.30545 20.5 3.5 16.6943 3.5 12C3.5 7.30568 7.30545 3.5 12 3.5C16.6945 3.5 20.5 7.30568 20.5 12Z",
    fill: "url(#paint0_linear_1673_12739)",
    stroke: "url(#paint1_linear_1673_12739)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5634 13.3108C13.2803 13.0371 12.7674 12.7668 12.0041 12.507C11.0436 12.2105 10.3491 11.8544 9.94164 11.4289C9.53095 10.9951 9.3297 10.4373 9.3297 9.7675C9.3297 9.06342 9.55059 8.48186 10.0005 8.03589C10.426 7.61116 10.9905 7.36448 11.6867 7.28852V6.47172C11.6841 6.41074 11.6939 6.34986 11.7154 6.29275C11.737 6.23563 11.77 6.18347 11.8123 6.1394C11.8546 6.09533 11.9054 6.06026 11.9616 6.03631C12.0178 6.01235 12.0783 6 12.1395 6C12.2006 6 12.2611 6.01235 12.3174 6.03631C12.3736 6.06026 12.4244 6.09533 12.4667 6.1394C12.509 6.18347 12.5419 6.23563 12.5635 6.29275C12.5851 6.34986 12.5949 6.41074 12.5923 6.47172V7.28934C13.3082 7.37592 13.8767 7.65853 14.2858 8.14371C14.7202 8.65339 14.9305 9.07731 14.9305 9.85735V9.97578C14.9272 10.1059 14.8736 10.2296 14.7808 10.3211C14.6881 10.4125 14.5635 10.4645 14.4332 10.4662C14.3029 10.4679 14.177 10.4191 14.0819 10.3301C13.9869 10.2411 13.93 10.1188 13.9234 9.98885L13.9168 9.75525C13.9168 9.33215 13.7499 9.07241 13.4301 8.72037L13.4292 8.71873C13.1151 8.36506 12.6848 8.18455 12.1203 8.18455C11.5435 8.18455 11.1099 8.3332 10.8031 8.61663C10.4996 8.89598 10.3433 9.27007 10.3433 9.75525C10.3433 10.2249 10.4881 10.5778 10.7638 10.831C11.0526 11.0907 11.5549 11.3464 12.2888 11.5939C13.0349 11.8389 13.5871 12.0799 13.9365 12.3184C14.2882 12.552 14.5558 12.8346 14.7317 13.1662C14.9125 13.4954 15 13.8858 15 14.3334C15 15.0424 14.7717 15.6264 14.3087 16.0724C13.8751 16.4897 13.2902 16.7315 12.5669 16.8075V17.5508C12.5669 17.6699 12.5195 17.7842 12.4352 17.8684C12.3508 17.9527 12.2363 18 12.117 18C11.9977 18 11.8832 17.9527 11.7988 17.8684C11.7144 17.7842 11.667 17.6699 11.667 17.5508V16.8148C10.853 16.7429 10.2034 16.475 9.73384 16.0021C9.24052 15.4998 9.00082 15.0138 9.00082 14.1725C8.99689 14.1032 9.00715 14.0339 9.03099 13.9688C9.05483 13.9036 9.09173 13.844 9.13945 13.7936C9.18716 13.7432 9.24468 13.703 9.30848 13.6756C9.37229 13.6481 9.44103 13.634 9.5105 13.634C9.57997 13.634 9.64871 13.6481 9.71252 13.6756C9.77632 13.703 9.83384 13.7432 9.88155 13.7936C9.92926 13.844 9.96617 13.9036 9.99001 13.9688C10.0138 14.0339 10.0241 14.1032 10.0202 14.1725C10.0202 14.7933 10.2034 15.071 10.5577 15.4108C10.9111 15.7473 11.4118 15.9221 12.0761 15.9221C12.652 15.9221 13.1077 15.7718 13.4554 15.4802C13.8056 15.1902 13.9806 14.8153 13.9806 14.3448C13.9806 13.916 13.8399 13.5746 13.5634 13.3108Z",
    fill: "url(#paint2_linear_1673_12739)",
    stroke: "url(#paint3_linear_1673_12739)",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79931 4.89446C3.91877 5.01337 3.9904 5.17802 3.99889 5.35321C4.00738 5.5284 3.95206 5.70022 3.84475 5.83194C3.73744 5.96366 3.58667 6.04482 3.42466 6.05807C3.26266 6.07132 3.10228 6.0156 2.97783 5.90283L2.19433 5.15937C2.07745 5.03986 2.00803 4.87607 2.00065 4.70244C1.99328 4.52881 2.04853 4.35885 2.15479 4.22829C2.26106 4.09772 2.41006 4.01672 2.57048 4.00231C2.73089 3.9879 2.89024 4.0412 3.01502 4.15101L3.79852 4.89446H3.79931ZM20.7996 19.8345C20.919 19.9534 20.9907 20.118 20.9991 20.2932C21.0076 20.4684 20.9523 20.6402 20.845 20.772C20.7377 20.9037 20.5869 20.9848 20.4249 20.9981C20.2629 21.0113 20.1025 20.9556 19.9781 20.8428L19.1938 20.0985C19.0769 19.979 19.0075 19.8152 19.0001 19.6416C18.9927 19.468 19.048 19.298 19.1543 19.1674C19.2605 19.0369 19.4095 18.9559 19.5699 18.9415C19.7304 18.9271 19.8897 18.9804 20.0145 19.0902L20.7988 19.8336L20.7996 19.8345Z",
    fill: "url(#paint4_linear_1673_12739)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1673_12739",
    x1: 14.7829,
    y1: 1.875,
    x2: 26.1193,
    y2: 15.9123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1673_12739",
    x1: 14.7829,
    y1: 1.875,
    x2: 26.1193,
    y2: 15.9123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1673_12739",
    x1: 12.9276,
    y1: 5.25,
    x2: 19.8478,
    y2: 9.53442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1673_12739",
    x1: 12.9276,
    y1: 5.25,
    x2: 19.8478,
    y2: 9.53442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1673_12739",
    x1: 14.4375,
    y1: 2.9375,
    x2: 24.8358,
    y2: 17.3279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayType);
export default __webpack_public_path__ + "static/media/payType.accd1dc0f32503bfccacda4b99b9bcb5.svg";
export { ForwardRef as ReactComponent };